import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

export interface CoreServiceData {
  /** 服务标识 */
  core_service_id: string
  /** 服务器名称 */
  name: string
  /** 服务状态,1=正常，2=异常, 3=启动中 */
  status: number
  /** cup使用率 */
  cpu_usage: number
  /** 物理内存已使用量总量 */
  used_memory_mb: number
}

export interface CoreServiceRes {
  /** 核心服务信息 */
  data?: CoreServiceData[]
}

export interface RestartServiceReq {
  /** 服务标识 */
  core_service_id?: string
}

@Injectable()
export class CoreServicesService {
  constructor (private http: Http) {

  }

  @InvokeThrottle()
  getCoreService () {
    return this.http.post<CoreServiceRes>('/metric/core_service_list', {})
  }

  @InvokeThrottle()
  restartService (data: RestartServiceReq) {
    return this.http.post<void>('/metric/core_service_restart', data)
  }
}
